'use client'

import { SvgIcon, type SxProps } from '@mui/material'
import LoginArrowSvg from '@/assets/login-arrow.svg'

export function LoginArrow({ sx }: { sx?: SxProps }) {
  return (
    <SvgIcon
      viewBox="0 0 369 96"
      sx={sx}
    >
      <LoginArrowSvg />
    </SvgIcon>
  )
}
